// extracted by mini-css-extract-plugin
export default {"Days":"Days_Days__6h6cR"};